import moment from 'moment';

// Бэкенд отдаёт наивные timestamp'ы в UTC (TIMESTAMP WITHOUT TIME ZONE, без суффикса
// "Z"/offset) — moment(x) по умолчанию парсит такую строку как локальное время,
// то есть без этой обёртки на экране был бы виден "голый" UTC, выданный за локальное.
export function utcToLocal(value) {
    return moment.utc(value).local();
}
